import {get} from '@/api/clients';
import {AppInitResponse} from '@/models/system/app-init';

export interface IpCheckResponse {
  allowed: boolean;
  clientIp: string;
  timestamp: number;
}

/**
 * (GET) 시스템 초기 조회
 * @returns AppInitResponseDTO
 * @author mark
 */
export const fetchAppInit = async (): Promise<AppInitResponse> => {
  return await get<AppInitResponse>('/system/init');
};

/**
 * (GET) 관리자 페이지 IP 접근 권한 체크
 * @returns IP 체크 결과
 * @author mark
 */
export const checkAdminIpAccess = async (): Promise<IpCheckResponse> => {
  return await get<IpCheckResponse>('/system/check-ip');
};
